const selector = {
    checkoutForm: '#form_checkout',
    signature: '#signature',
    orderNumber: '#order_number',
    tagSerialNumber: '#tag_serial_number',
    tagVerificationCode: '#tag_verification_code',
    phoneNumber: '#phone_number',
    cardholderName: '#cardholder_name',
    cardholderSurname: '#cardholder_surname',
    cardholderEmail: '#cardholder_email',
    errorMessage: '#error_message',
    preloader: '#preloader',
    invalidFeedback: '.invalid-feedback',
    isInvalid: '.is-invalid',
    checkTerms: '#check_terms',
    captchaHolder: '#captcha_holder',
    captcha: '#captcha',
    reloadCaptcha: '#reload_captcha',
    deliveryMethod: 'input[name="delivery_method"]',
    deliveryMethodChecked: 'input[name="delivery_method"]:checked',
    btn: {
        submit: '#btn_submit',
        addVehicle: '#btn_add_vehicle',
        removeVehicle: '.js_btn_remove_vehicle',
    },
    tpl: {
        addVehicleInput: '#tpl_add_vehicle_input',
    },
    addInputVehicleContainer: '.js_add_vehicle_input_container',
    totalAmount: '#total_amount',
    amount: 'input[name="amount"]',
    registrationInput: '.js_registration_input',
    dmPersonalInfoContainer: '#dm_personal_info_container',
    dmPostInfoContainer: '#dm_post_info_container',
    dmParcelMachineInfoContainer: '#dm_parcel_machine_info_container'
};

export {selector};